export const environment = {
  production: false,
  nhsApiUrl: 'https://membersapidev.nhsbenchmarking.nhs.uk/',
  icsApiUrl: 'https://icsapidev.nhsbenchmarking.nhs.uk/',
  nhsApiUrlTEST: 'https://membersapidev.nhsbenchmarking.nhs.uk/activityLog/',
  devAPIUrl: 'https://data-extract-service.bmcapps.p.azurewebsites.net/api/AzureFunctionApp?code=vQ_RpSNyngQ-6mRxMrURoScN-iVKO7HaGRf_Z6DoQ2sEAzFusMXnsg==',
};
